export const gcpGpuCatalogPaths = {
  catalog: (connectionId, params = {}) => {
    const query = new URLSearchParams();
    if (params.zone) query.set('zone', String(params.zone));
    if (params.acceleratorType) query.set('acceleratorType', String(params.acceleratorType));
    if (params.acceleratorCount) query.set('acceleratorCount', String(params.acceleratorCount));
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return `/compute/cloud-account-connections/${connectionId}/gcp/gpus/catalog${suffix}`;
  },
};
